import { render, staticRenderFns } from "./ListCollective.vue?vue&type=template&id=60d11e3e&scoped=true"
import script from "./ListCollective.vue?vue&type=script&lang=js"
export * from "./ListCollective.vue?vue&type=script&lang=js"
import style0 from "./ListCollective.vue?vue&type=style&index=0&id=60d11e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d11e3e",
  null
  
)

export default component.exports